
import * as Highcharts from 'highcharts';
export class chartdata {
  static token: string = "";
  static area_bar: any = {

    chart: {
        type: 'area',
        zoomType: 'x',
        panning: true,
        panKey: 'shift',
        scrollablePlotArea: {
            minWidth: 600
        }
    },
    title: {
        text: '每月花費',
        align: 'left'
    },

    credits: {
        enabled: false
    },
    annotations: [{
        draggable: '',
        labelOptions: {
            backgroundColor: 'rgba(255,255,255,0.5)',
            verticalAlign: 'top',
            y: 15
        },
    }],


    xAxis: {
        type: 'datetime',
        labels: {
            format: '{value:%Y-%m}' // Format the date as "YYYY-MM-DD"
        },
        title: {
            text: '日期'
        }
    },
    yAxis: {
        startOnTick: true,
        endOnTick: false,
        maxPadding: 0.35,
        title: {
            text: null
        },
        labels: {
            format: '{value}'
        },
    },
    tooltip: {
        headerFormat: '<strong>Date: {point.key:%Y-%m}</strong><br>',
        pointFormat: '{point.y}',
        shared: true
    },

    series: [
        {
            data:  [
                [new Date('2023-02').getTime(), 1159],
                [new Date('2023-03').getTime(), 1158],
                [new Date('2023-04').getTime(), 1158],
                [new Date('2023-05').getTime(), 1158],
                [new Date('2023-06').getTime(), 1161],
                [new Date('2023-07').getTime(), 1167],
                [new Date('2023-08').getTime(), 1170]
            ],
            lineColor: Highcharts.getOptions().colors[1],
            color: Highcharts.getOptions().colors[2],
            fillOpacity: 0.5,
            name: 'Elevation',
            marker: {
                enabled: false
            },
            threshold: null
        },
    ],
  };
  static single_bar: any = {
    chart: {
      type: "column",
    },
    title: {
      text: "分群圖",
    },
    xAxis: {
      categories: ["Apples", "Oranges", "Pears", "Grapes", "Bananas"],
    },
    yAxis: {
      allowDecimals: false,
      title: {
        text: "人數",
      },
    },
    tooltip: {
        formatter: function () {
          return `<b>${chartdata.thousandSeparator(this.y)}<b>`
        },
      },
      plotOptions: {
        column: {
          stacking: "normal",
          dataLabels: {
            enabled: true,
            formatter: function () {
                return Highcharts.numberFormat(this.y, 0, '.', ','); // Custom formatting
            },
          },
        },
      },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "John",
        data: [5, 3, 4, 7, 20],
        stack: "male",
      },
    ],
  };
  static muti_bar: any = {
    chart: {
      type: "column",
      events: {
        // 清除殘留的描述
        load: function () {
          var chart = this;
          var totals = [];
          var counts = [];
          this.series.forEach(function (s) {
            s.data.forEach(function (d, i) {
              if (!totals[i]) {
                totals[i] = 0;
                counts[i] = 0;
              }
              totals[i] += d.y;
              if (d.y != 0) {
                counts[i] += 1;
              }
            });
          });

          this.series.forEach(function (s, a) {
            s.points.forEach(function (p, i) {
              var x = p.plotX + p.series.xAxis.left,
                y = p.plotY + p.series.yAxis.top - 20, // 調整位置
                value = totals[i];
              if (value != 0 && counts[i] > a) {
                counts[i] = -1;
                var text = chart.renderer
                  .text(value.toLocaleString(), x, y)
                  .attr({
                    align: "center",
                    zIndex: 0,
                    rotation: 0,
                  })
                  .add();
              }
            }, this);

            // chart.renderer.text('aa', x, 30).add();
            // s.update({
            //   dataLabels: {
            //     enabled: true,
            //     formatter: function() {
            //       if (this.y === 0) {
            //         return '';
            //       }
            //       return this.y.toLocaleString();
            //     }
            //   },
            //   tooltip: {
            //     enabled: false
            //   }
            // });
          });
        },
      },
    },
    title: {
      text: "分群圖",
    },
    xAxis: {
      categories: ["Apples", "Oranges", "Pears", "Grapes", "Bananas"],
    },
    yAxis: {
      allowDecimals: false,
      min: 0,
      title: {
        text: "人數",
      },
    },
    tooltip: {
      formatter: function () {
        return `<b>${chartdata.thousandSeparator(this.y)}<b>`
      },
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: false,
          formatter: function (value) {
            if (this.point.total === null) {
              return;
            }

            return this.point.total;
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "John",
        data: [5, 3, 4, 7, 20],
        stack: "male",
      },
      {
        name: "Joe",
        data: [3, 4, 4, 2, 5],
        stack: "male",
      },
      {
        name: "Jane",
        data: [2, 5, 6, 2, 1],
        stack: "female",
      },
      {
        name: "Jane",
        data: [2, 5, 6, 2, 1],
        stack: "female",
      },
      {
        name: "Jane",
        data: [2, 5, 6, 2, 1],
        stack: "female",
      },
      {
        name: "Janet",
        data: [3, 0, 4, 4, 3],
        stack: "female",
      },
    ],
  };
  static line: any = {
    chart: {
      type: 'line'
    },
    title: {
      text: "月收支折線圖",
    },
    subtitle: {
      text: "過去幾天數據",
    },
    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "middle",
      borderWidth: 0,
    },
    xAxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    tooltip: {
      formatter: function () {
        return `<b>${chartdata.thousandSeparator(this.y)}<b>`
      },
    },
    yAxis: {
      title: {
        text: "",
      },
    },
    plotOptions: {
        line: {
            dataLabels: {
                enabled: true,
                formatter: function () {
                    return Highcharts.numberFormat(this.y, 0, '.', ','); // Custom formatting
                }
            }
        }
    },
    series: [
      {
        name: "Tokyo",
        type: "line",
        data: [1, 2, 3, 4, 5, 6],
      },
      {
        name: "test",
        type: "line",
        data: [7, 7, 8, 8, 5, 6],
      },
      {
        name: "test2",
        type: "line",
        data: [7, 11, 8, 18, 5, 6],
      },
    ],
  };

  static line1: any = {
    chart: {
      type: 'line'
    },
    title: {
      text: "月收支折線圖",
    },
    subtitle: {
      text: "過去幾天數據",
    },
    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "middle",
      borderWidth: 0,
    },
    xAxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    tooltip: {
      formatter: function () {
        return `<b>${chartdata.thousandSeparator(this.y)}<b>`
      },
    },
    yAxis: {
      title: {
        text: "",
      },
    },
    plotOptions: {
        line: {
            dataLabels: {
                enabled: true,
                formatter: function () {
                    return Highcharts.numberFormat(this.y, 0, '.', ','); // Custom formatting
                }
            }
        }
    },
    series: [
      {
        name: "Tokyo",
        type: "line",
        data: [1, 2, 3, 4, 5, 6],
      },
    ],
  };
    static line2: any = {
    chart: {
      type: 'line'
    },
    title: {
      text: "月收支折線圖",
    },
    subtitle: {
      text: "過去幾天數據",
    },
    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "middle",
      borderWidth: 0,
    },
    xAxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    tooltip: {
      formatter: function () {
        return `<b>${chartdata.thousandSeparator(this.y)}<b>`
      },
    },
    yAxis: {
      title: {
        text: "",
      },
    },
    plotOptions: {
        line: {
            dataLabels: {
                enabled: true,
                formatter: function () {
                    return Highcharts.numberFormat(this.y, 0, '.', ','); // Custom formatting
                }
            }
        }
    },
    series: [
      {
        name: "Tokyo",
        type: "line",
        data: [1, 2, 3, 4, 5, 6],
      },
      {
        name: "test",
        type: "line",
        data: [7, 7, 8, 8, 5, 6],
      },
    ],
  };

  static staticline: any = {
    chart: {
      type: 'line'
    },
    title: {
      text: "月收支折線圖",
    },
    subtitle: {
      text: "過去幾天數據",
    },
    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "middle",
      borderWidth: 0,
    },
    xAxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    tooltip: {
      formatter: function () {
        return `<b>${chartdata.thousandSeparator(this.y)}<b>`
      },
    },
    yAxis: {
      title: {
        text: "",
      },
    },
    plotOptions: {
        line: {
            dataLabels: {
                enabled: true,
                formatter: function () {
                    return Highcharts.numberFormat(this.y, 0, '.', ','); // Custom formatting
                }
            }
        }
    },

    series: [
      {
        name: "Tokyo",
        type: "line",
        data: [1, 2, 3, 4, 5, 6],
      },
      {
        name: "test",
        type: "line",
        data: [7, 7, 8, 8, 5, 6],
      },
      {
        name: "test2",
        type: "line",
        data: [7, 11, 8, 18, 5, 6],
      },
      {
        name: "test2",
        type: "line",
        data: [7, 11, 8, 18, 5, 6],
      },
      {
        name: "test2",
        type: "line",
        data: [7, 11, 8, 18, 5, 6],
      },
      {
        name: "test2",
        type: "line",
        data: [7, 11, 8, 18, 5, 6],
      },
    ],
  };
  static bar: any = {
    chart: {
      type: "bar",
    },
    title: {
      text: "年紀性別對照圖",
    },
    subtitle: {
      text: "",
    },
    xAxis: [
      {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        reversed: false,
        labels: {
          step: 1,
        },
        accessibility: {
          description: "Age (male)",
        },
      },
    ],
    yAxis: {
      title: {
        text: null,
      },
      accessibility: {
        description: "Percentage population",
        rangeDescription: "Range: 0 to 5%",
      },
    },
    plotOptions: {
      series: {
        stacking: "normal",
      },
    },
    series: [
      {
        name: "Tokyo",
        type: "line",
        data: [1, 2, 3, 4, 5, 6],
      },
      {
        name: "fuck",
        type: "line",
        data: [7, 7, 8, 8, 5, 6, 9, 3, 2],
      },
    ],
  };

  static pie: any = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",
    },
    title: {
      text: "比例圖",
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.percentage:.1f} %",
        },
      },
    },
    series: [
      {
        name: "Brands",
        colorByPoint: true,
        data: [
          {
            name: "Chrome",
            y: 61.41,
            sliced: true,
            selected: true,
          },
          {
            name: "Internet Explorer",
            y: 11.84,
          },
          {
            name: "Firefox",
            y: 10.85,
          },
          {
            name: "Edge",
            y: 4.67,
          },
          {
            name: "Safari",
            y: 4.18,
          },
          {
            name: "Sogou Explorer",
            y: 1.64,
          },
          {
            name: "Opera",
            y: 1.6,
          },
          {
            name: "QQ",
            y: 1.2,
          },
          {
            name: "Other",
            y: 2.61,
          },
        ],
      },
    ],
  };

  static assign_num_data(data: any,obj:any,num: number) {
    data.series = [];
    const alpha = 0.5;
    for (let i = 0; i <= num; i++) {
      obj.color= this.getRandomColor(alpha);
      data.series.push(obj)
    }
    return data;
  }

  static getRandomColor(alpha) {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return `rgba(${parseInt(color.slice(1, 3), 16)}, ${parseInt(color.slice(3, 5), 16)}, ${parseInt(color.slice(5, 7), 16)}, ${alpha})`;
  }

  static filterChartData(data: any) {
    const transformedData = {};
    data.forEach(obj => {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (!transformedData[key]) {
            transformedData[key] = [];
          }
          transformedData[key].push(parseInt(obj[key]));
        }
      }
    });
    return transformedData;
  }
  static filterChartDate(data: any) {
    let categories = [];
    data.forEach((v) => {
      categories.push(v.target_date);
    });
    return categories;
  }

  static thousandSeparator(value){
    if (!value) return 0;
    const parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `<b>${parts.join(".")}<b>`;
  }
}
